

const ReportsIcon = ()=>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 23.364 25.488"><defs></defs><path className="a" d="M16.868,6.372a1.062,1.062,0,1,1,0,2.124h-8.5a1.062,1.062,0,1,1,0-2.124Zm8.185,18.8a1.062,1.062,0,0,1-1.5,0l-2.556-2.556a4.816,4.816,0,1,1,1.5-1.5l2.556,2.556A1.062,1.062,0,0,1,25.053,25.177ZM18.461,21.24a2.655,2.655,0,1,0-2.655-2.655A2.655,2.655,0,0,0,18.461,21.24Zm-4.779,2.124H7.31a3.186,3.186,0,0,1-3.186-3.186V5.31A3.186,3.186,0,0,1,7.31,2.124H20.054a1.062,1.062,0,0,1,1.062,1.062v8.5a1.062,1.062,0,0,0,2.124,0v-8.5A3.186,3.186,0,0,0,20.054,0H7.31A5.316,5.316,0,0,0,2,5.31V20.178a5.316,5.316,0,0,0,5.31,5.31h6.372a1.062,1.062,0,1,0,0-2.124Z" transform="translate(-2)"/></svg>
    )
}

export default ReportsIcon